// ─────────────────────────────────────────────────────────
// Content layer over the Grav export in data/posts.json.
//
// posts.json is a faithful export of the old Grav site, so it still
// carries two entries that are pages rather than blog posts:
//   privacy-policy — surfaced on its own page, linked from the footer
//   home           — the old Grav landing page, whose body is unrendered
//                    Twig template code; it is dropped entirely
// ─────────────────────────────────────────────────────────
import postsData from './data/posts.json';

// Grav category -> the section it belongs to on this site.
export const SECTIONS = [
  {
    key: 'equipment',
    label: 'Equipment',
    category: 'Equipment',
    blurb: 'Rigs, amps, tuners, antennas, and the kit that makes it all work.',
  },
  {
    key: 'ota',
    label: 'On The Air',
    category: 'On The Air (OTA)',
    blurb: 'Activations, contests, portable operating, and time on the bands.',
  },
  {
    key: 'general',
    label: 'General',
    category: 'General',
    blurb: 'Everything else — projects, travel, music, and the occasional detour.',
  },
];

const SECTION_BY_CATEGORY = Object.fromEntries(
  SECTIONS.map((s) => [s.category, s])
);

export const PRIVACY_POST = postsData.find((p) => p.slug === 'privacy-policy') || null;

// Every real post, newest first (posts.json is already sorted that way).
export const POSTS = postsData
  .filter((p) => SECTION_BY_CATEGORY[p.category])
  .map((p) => ({ ...p, section: SECTION_BY_CATEGORY[p.category].key }));

export const getSection = (key) => SECTIONS.find((s) => s.key === key) || null;

export const getPost = (slug) => POSTS.find((p) => p.slug === slug) || null;

export const postsInSection = (key) => POSTS.filter((p) => p.section === key);

export const countInSection = (key) => postsInSection(key).length;

/** Newest n posts across every section. */
export const latestPosts = (n) => POSTS.filter((p) => p.date).slice(0, n);

const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
                'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

/**
 * Format an ISO YYYY-MM-DD date for display. Parsed by hand rather than
 * via Date, which would treat the value as UTC midnight and shift the day
 * backwards for viewers in negative offsets.
 */
export function formatDate(iso) {
  if (!iso) return '';
  const [y, m, d] = iso.split('-').map(Number);
  if (!y || !m || !d) return iso;
  return `${MONTHS[m - 1]} ${d}, ${y}`;
}

/** Strip Markdown down to plain prose for card excerpts. */
export function excerpt(markdown, length = 160) {
  const text = markdown
    .replace(/```[\s\S]*?```/g, ' ')
    .replace(/!\[[^\]]*\]\([^)]*\)/g, ' ')
    .replace(/\[([^\]]*)\]\([^)]*\)/g, '$1')
    .replace(/^#{1,6}\s*/gm, '')
    .replace(/[*_`>#-]/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
  return text.length > length ? `${text.slice(0, length).trimEnd()}…` : text;
}
